import { IS_SERVER } from "@/constants";
import { useConfig } from "@/contexts/cdpConfig";
import { useCustomerAction, useIsMobileWeb } from "@/hooks";
import { isFeatureFlagActive } from "@/utils/kameleoon/isFeatureFlagActive";
import { useCallback } from "react";
export function useCallWithReturnRequestCallback(onReturn) {
    const { customerActionExposeContactPhoneCall } = useCustomerAction();
    const isPreviewMode = useConfig().previewMode;
    const isMobileWeb = useIsMobileWeb();
    const triggerRequestCallbackModal = isFeatureFlagActive("triggerrequestcallbackmodal");
    return useCallback(async (phoneNumber) => {
        if (IS_SERVER || !phoneNumber || isPreviewMode)
            return;
        await customerActionExposeContactPhoneCall();
        // 1) Kick off the native dial
        window.location.href = `tel:${phoneNumber.replace(/\s/g, "")}`;
        // 2) Only on mobile web + kameleoon feature flag is turned on
        if (!isMobileWeb || !triggerRequestCallbackModal)
            return;
        let didHide = false;
        const handleVisibility = () => {
            if (document.visibilityState === "hidden") {
                didHide = true;
            }
            if (document.visibilityState === "visible" && didHide) {
                cleanup();
                onReturn();
            }
        };
        const cleanup = () => {
            document.removeEventListener("visibilitychange", handleVisibility);
        };
        document.addEventListener("visibilitychange", handleVisibility);
    }, [
        isPreviewMode,
        isMobileWeb,
        triggerRequestCallbackModal,
        onReturn,
        customerActionExposeContactPhoneCall,
    ]);
}
